module.exports = __webpack_public_path__ + "static/media/kaison.83c5c7a4.jpeg";